import { render, staticRenderFns } from "./LandingBirthdayFR.vue?vue&type=template&id=d078ff4a&scoped=true"
import script from "./LandingBirthdayFR.vue?vue&type=script&lang=js"
export * from "./LandingBirthdayFR.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d078ff4a",
  null
  
)

export default component.exports